import { gql } from "@apollo/client";

// We need to find a way to test these fragments in isolation

const BLOCKS_FRAGMENT = gql`
  fragment blocks on TextBlock {
    id
    label
    value
  }
`;
const ACTIONS_FRAGMENT = gql`
  fragment actions on ActionBlock {
    primaryActionId
    primaryLabel
    secondaryActionId
    secondaryLabel
  }
`;

const MEMBERSHIP_MANAGEMENT_FRAGMENT = gql`
  fragment membershipManagement on MembershipManagementComponent {
    id
    header
    footer
    actions {
      ...actions
    }
    blocks {
      ...blocks
    }
  }
  ${BLOCKS_FRAGMENT}
  ${ACTIONS_FRAGMENT}
`;

export const GET_MEMBER_MANAGEMENT = gql`
  query getMyMembershipManagement {
    getMyMembershipManagement {
      id
      header
      membershipManagement {
        ...membershipManagement
      }
    }
  }
  ${MEMBERSHIP_MANAGEMENT_FRAGMENT}
`;
